import { Separator } from "@choose/ui/separator";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { ProfileForm } from "~/components/common/settings/members/profile-form";
import { useCurrentUserQuery } from "~/graphql/graphql.gen";

export const Route = createFileRoute(
  "/_auth/_app_shell/_settings-navigation/settings/profile",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();
  const { data: currentUser } = useCurrentUserQuery(undefined, {
    select: (data) => data.currentUser,
  });

  return (
    <>
      <title>{`${t("settings.profile.title")} - ${t("app_name")}`}</title>
      <div className="bg-background w-full overflow-auto">
        <div className="m-auto max-w-2xl p-8">
          <header className="mt-14">
            <h1 className="text-2xl">{t("settings.profile.title")}</h1>
            <span className="text-muted-foreground mt-1 text-sm">
              {t("settings.profile.subtitle")}
            </span>
          </header>
          <Separator className="my-8" />
          <div>{currentUser ? <ProfileForm user={currentUser} /> : null}</div>
        </div>
      </div>
    </>
  );
}
